export default {
  minLoopTime: 40,
  maxLoopTime: 100,
}
